import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "Polygon-Modal-Container-Resizable pointer-events-auto" }
const _hoisted_2 = { class: "grid-x h-full" }
const _hoisted_3 = {
  key: 0,
  class: "cell shrink"
}
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "cell auto Modal-body_element" }
const _hoisted_6 = { class: "grid-y modal-grid" }
const _hoisted_7 = { class: "cell shrink disable-select" }
const _hoisted_8 = { class: "cell auto Modal-body_element" }
const _hoisted_9 = {
  key: 0,
  class: "cell shrink"
}
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 1,
  class: "cell shrink"
}
const _hoisted_12 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" <div class=\"Polygon-Modal-Overlay\" v-if=\"displayOverlay\"></div> "),
      _createElementVNode("div", {
        class: "Polygon-Modal rounded-xl bg-bg overflow-hidden",
        style: _normalizeStyle(_ctx.styleObject)
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.resizable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", {
                  title: _ctx.RESIZE_BAR_TITLE,
                  class: "Modal-size-handle vertical bg-bg-dark hover:bg-black",
                  onPointerdown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.on_move_or_resize_start && _ctx.on_move_or_resize_start(...args)))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "Modal-title text-center cursor-grab bg-bg-dark text-gray-400 hover:bg-black hover:text-white",
                  onPointerdown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.on_move_or_resize_start && _ctx.on_move_or_resize_start(...args)))
                }, _toDisplayString(_ctx.title), 33 /* TEXT, HYDRATE_EVENTS */),
                (_ctx.displayTitleCloseButton)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "title-close-button mr-4 text-gray-400 hover:text-white",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop"]))
                    }, " ✕ "))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _renderSlot(_ctx.$slots, "default", { class: "full_height_container" })
              ]),
              (_ctx.resizable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", {
                      title: _ctx.RESIZE_BAR_TITLE,
                      class: "Modal-size-handle horizontal bg-emerald-700 hover:bg-emerald-800",
                      onPointerdown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.on_resize_or_move_start && _ctx.on_resize_or_move_start(...args)))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_10)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          (_ctx.resizable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", {
                  title: _ctx.RESIZE_BAR_TITLE,
                  class: "Modal-size-handle vertical bg-emerald-700 hover:bg-emerald-800",
                  onPointerdown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.on_resize_or_move_start && _ctx.on_resize_or_move_start(...args)))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_12)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ], 4 /* STYLE */)
    ]),
    _createCommentVNode(" <TransitionRoot as=\"template\" :show=\"displayed\">\n\t\t<Dialog as=\"div\" class=\"relative z-10 Polygon-Modal-Container2\" @close=\"close\">\n\t\t\t<TransitionChild\n\t\t\t\tas=\"template\"\n\t\t\t\tenter=\"ease-out duration-0\"\n\t\t\t\tenter-from=\"opacity-0\"\n\t\t\t\tenter-to=\"opacity-100\"\n\t\t\t\tleave=\"ease-in duration-0\"\n\t\t\t\tleave-from=\"opacity-100\"\n\t\t\t\tleave-to=\"opacity-0\"\n\t\t\t>\n\t\t\t\t<div class=\"fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity\" />\n\t\t\t</TransitionChild>\n\n\t\t\t<div class=\"fixed z-10 inset-0 overflow-y-auto\">\n\t\t\t\t<div\n\t\t\t\t\t:class=\"[\n\t\t\t\t\t\tfullHeight ? 'sm:items-stretch' : 'sm:items-center',\n\t\t\t\t\t\t'flex items-end justify-center min-h-full p-4 text-center sm:p-0',\n\t\t\t\t\t]\"\n\t\t\t\t>\n\t\t\t\t\t<TransitionChild\n\t\t\t\t\t\tas=\"template\"\n\t\t\t\t\t\tenter=\"ease-out duration-0\"\n\t\t\t\t\t\tenter-from=\"opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95\"\n\t\t\t\t\t\tenter-to=\"opacity-100 translate-y-0 sm:scale-100\"\n\t\t\t\t\t\tleave=\"ease-in duration-0\"\n\t\t\t\t\t\tleave-from=\"opacity-100 translate-y-0 sm:scale-100\"\n\t\t\t\t\t\tleave-to=\"opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<DialogPanel\n\t\t\t\t\t\t\tclass=\"relative bg-bg rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6 flex flex-col\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<div class=\"hidden sm:block absolute top-0 right-0 pt-4 pr-4\">\n\t\t\t\t\t\t\t\t<button\n\t\t\t\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\t\t\t\tclass=\"text-text hover:text-white cursor-pointer focus:outline-0\"\n\t\t\t\t\t\t\t\t\t@click=\"close\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t<span class=\"sr-only\">Close</span>\n\t\t\t\t\t\t\t\t\t<XMarkIcon class=\"h-6 w-6\" aria-hidden=\"true\" />\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\tclass=\"sm:flex sm:items-start cursor-grab hover:bg-bg-light\"\n\t\t\t\t\t\t\t\t@mousedown=\"on_move_start\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<div class=\"mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left\">\n\t\t\t\t\t\t\t\t\t<DialogTitle as=\"h3\" class=\"text-lg leading-6 font-medium text-white\">\n\t\t\t\t\t\t\t\t\t\t{{ title }}\n\t\t\t\t\t\t\t\t\t</DialogTitle>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div v-if=\"fullHeight\" class=\"flex-1\">\n\t\t\t\t\t\t\t\t<slot></slot>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<slot v-else></slot>\n\t\t\t\t\t\t</DialogPanel>\n\t\t\t\t\t</TransitionChild>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</Dialog>\n\t</TransitionRoot> ")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}